import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Send, ClipboardList, FileText, CalendarCheck, Truck, PackageCheck } from "lucide-react";
import { PROCESS } from "@/lib/site";
import { Reveal, Eyebrow } from "@/components/Reveal";

const ICONS = [Send, ClipboardList, FileText, CalendarCheck, Truck, PackageCheck];

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 78%", "end 55%"] });
  const scaleX = useTransform(scrollYProgress, [0, 1], [0, 1]);
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section id="ablauf" ref={ref} data-testid="process-section" className="relative w-full bg-[#0a0a0a] grain py-20 sm:py-24 lg:py-32">
      <div className="w-full px-5 sm:px-8 lg:px-12">
        <Reveal>
          <Eyebrow chapter="06">Ablauf</Eyebrow>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display uppercase font-black leading-[0.9] tracking-tight text-white text-[clamp(2.1rem,7.5vw,5rem)] max-w-[1100px]">
            So <span className="text-[#f95700]">funktioniert es</span>
          </h2>
        </Reveal>

        <div className="mt-12 sm:mt-16 relative">
          <div className="hidden lg:block absolute top-[42px] left-0 right-0 h-[2px] bg-white/10">
            <motion.div style={{ scaleX }} className="h-full bg-[#f95700] origin-left" />
          </div>
          <div className="lg:hidden absolute top-0 bottom-0 left-[21px] w-[2px] bg-white/10">
            <motion.div style={{ scaleY }} className="w-full h-full bg-[#f95700] origin-top" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-6 gap-8 lg:gap-6">
            {PROCESS.map((p, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={p.t} delay={i * 0.07} className="relative group flex lg:block gap-5">
                  <div className="relative z-10 w-11 h-11 lg:w-[84px] lg:h-[84px] shrink-0 bg-[#141414] border border-white/15 grid place-items-center group-hover:border-[#f95700] transition-colors duration-500">
                    <Icon size={20} className="lg:hidden text-[#f95700]" />
                    <Icon size={28} className="hidden lg:block text-[#f95700] transition-transform duration-500 group-hover:scale-110" />
                    <span className="hidden lg:grid absolute -top-3 -right-3 w-8 h-8 bg-[#f95700] place-items-center font-mono-t text-[12px] font-bold text-white">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <div className="lg:mt-6 pb-2">
                    <span className="lg:hidden font-mono-t text-[11px] text-[#f95700] block mb-1">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3 className="font-display text-lg sm:text-xl font-bold uppercase tracking-tight text-white leading-tight">
                      {p.t}
                    </h3>
                    <p className="mt-2 text-[13px] text-neutral-400 leading-relaxed max-w-sm">{p.d}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
